import { useEffect, useState } from "react";
import useAxios from "../hooks/useAxios";
import CurrencyFormat from "react-currency-format";
import clsx from "clsx";
import { Spinner } from "react-bootstrap";
import { AiFillExclamationCircle } from "react-icons/ai";

const UpdatePlanUf = ({
    financialUnitAccountId,
    defaultValue,
    closedAt,
    approveAt,
    canUpdate
}) => {
    const [hasError, setHasError] = useState(false);
    const [currentValue, setCurrentValue] = useState('');

    const [{ loading: loadingUpdatePlanAccount }, updatePlanAccount] = useAxios(
        { url: `/financial-unit-accounts/${financialUnitAccountId}`, method: 'PUT' },
        { useCache: false, manual: true }
    );

    useEffect(() => {
        if (defaultValue !== undefined && defaultValue !== null) setCurrentValue(defaultValue);
    }, [defaultValue]);

    const handleChange = (e) => {
        setHasError(false);
        if (canUpdate) {
            try {
                setCurrentValue(e.target.value);
                updatePlanAccount({
                    data: {
                        amount: Number(e.target.value)
                    }
                });
            } catch (error) {
                setHasError(true);
            }
        }
    };

    const isReadOnly = !financialUnitAccountId || !!closedAt || !!approveAt || !canUpdate;
    const tooltipTitle = !financialUnitAccountId
        ? 'Este valor es solo de muestra no puede ser editado.'
        : closedAt
        ? 'El plan ya ha sido cerrado. Para poder editarlo debe abrir el plan.'
        : approveAt
        ? 'El plan ya ha sido cerrado y aprobado. Para poder editarlo debe abrirlo de nuevo.'
        : !canUpdate
        ? 'No tienes permisos para editar este valor.'
        : '';

    return (
        <div className="pm-cell-container position-relative">
            <CurrencyFormat
                className={clsx(["form-control pm-numeric-input"], {
                    'val-error': hasError,
                    'val-positive': !hasError && Number(currentValue) > 0,
                    'val-negative': !hasError && Number(currentValue) < 0,
                })}
                value={currentValue}
                decimalSeparator=","
                thousandSeparator="."
                isNumericString
                readOnly={isReadOnly}
                title={tooltipTitle}
                suffix=" UF"
                onValueChange={(e) => handleChange({ target: { name: 'amount', value: e.value } })}
                placeholder="0 UF"
            />

            {loadingUpdatePlanAccount && (
                <div className="position-absolute end-0 me-1" style={{ top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                    <Spinner variant="primary" style={{ width: 14, height: 14 }} animation="border" />
                </div>
            )}

            {!loadingUpdatePlanAccount && hasError && (
                <div className="position-absolute end-0 me-1" style={{ top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                    <AiFillExclamationCircle className="text-danger" style={{ fontSize: 13 }} />
                </div>
            )}
        </div>
    );
};

export default UpdatePlanUf;